import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { registerUser, apiError, registerUserFailed } from "../../store/actions"

// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"

// import images
import logoLightPng from "../../assets/images/logo-light.png"
import logoDark from "../../assets/images/logo-dark.png"
import cplLogo from "../../assets/images/cpl-logo.png"

const NewPassword = props => {
  const [isConfirmPasswordShow, setIsConfirmPasswordShow] = useState(false)
  const [isPasswordShow, setIsPasswordShow] = useState(false)

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    props.registerUser(values)
  }

  useEffect(() => {
    props.apiError("")
  }, [])

  return (
    <React.Fragment>
      <MetaTags>
        <title>New Password | CPL Group</title>
      </MetaTags>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden mb-2">
                <CardBody className="pt-0 px-0">
                  <div className=" pb-1" style={{ backgroundColor: "#FF8B6C" }}>
                    <h4
                      className="pt-1 text-white font-size-15 font-italic mb-0 text-center fw-normal !important"
                      style={{ fontStyle: "italic" }}
                    >
                      Tenant
                    </h4>
                    <h2 className="text-white text-center fw-bold">
                      NEW PASSWORD
                    </h2>
                  </div>
                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-0 text-center fw-bold">
                      your_email@email.com !
                    </h4>
                    <p className="text-muted text-center mt-0">
                      Please enter new password below
                    </p>
                    <AvForm
                      className="form-horizontal mt-4 mx-3"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v)
                      }}
                    >

                      <div className="mb-3 position-relative">
                        <AvField
                          d="newPassword"
                          name="newPassword"
                          label="New Password"
                          className="form-control"
                          placeholder="Enter New Password"
                          type={isPasswordShow ? "text" : "password"}
                          required
                        />
                        <i
                          className={`mdi ${
                            isPasswordShow ? "mdi-eye" : "mdi-eye-off"
                          } fs-3 position-absolute`}
                          style={{
                            top: "27px",
                            right: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => setIsPasswordShow(!isPasswordShow)}
                        ></i>
                      </div>

                      <div className="mb-3 position-relative">
                        <AvField
                          d="newPassword"
                          name="confirmPassword"
                          label="Confirm New Password"
                          className="form-control"
                          placeholder="Enter New Password"
                          type={isConfirmPasswordShow ? "text" : "password"}
                          required
                        />
                        <i
                          className={`mdi ${
                            isConfirmPasswordShow ? "mdi-eye" : "mdi-eye-off"
                          } fs-3 position-absolute`}
                          style={{
                            top: "27px",
                            right: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setIsConfirmPasswordShow(!isConfirmPasswordShow)
                          }
                        ></i>
                      </div>

                      <div className=" mt-5 px-5 d-flex justify-content-center">
                        <button
                          className="btn btn-primary waves-effect waves-light btn-lg rounded-pill w-100 mx-auto max-width-250"
                          style={{
                            fontWeight: "bold",
                            fontSize: "20px",
                            height: "50px",
                            maxWidth: "300px",
                          }}
                          type="submit"
                        >
                          SAVE
                        </button>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="text-center">
                <p className="text-muted mb-0 font-size-14">
                  Remember it? &nbsp;
                  <Link to="/login" className="text-primary">
                    Sign in Here
                  </Link>
                </p>
              </div>
              <div className="text-center mt-2">
                <img src={cplLogo} height={50} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

NewPassword.propTypes = {
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}

const mapStatetoProps = state => {
  const { user, registrationError, loading } = state.Account
  return { user, registrationError, loading }
}

export default connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
})(NewPassword)
